export const SIDEBAR_CONSTANTS = {
  WIDTH: {
    DESKTOP: "16rem",
    ICON: "var(--sizing-14)",
  },
  KEYBOARD_SHORTCUT: "b",
  MOBILE_BREAKPOINT: 720,
} as const;
